<template>
  <div class="login-page-container">
    <div class="login">
      <div class="left">
        <img src="../../static/img/ejkloginBG-2.png" alt="" />
      </div>
      <div class="right">
        <img class="HZlogo" src="../../static/img/ejklogo_02.png" alt="" />
        <h3 class="title">e金科后台管理系统</h3>
        <div class="message-content" ref="bm">
          <input
            type="tel"
            class="text1"
            style="text-align: left"
            @focus="phoneNumFocus"
            placeholder="请输入账号"
            @input="checktel"
            @blur="phoneNumBlur"
            v-model="telPhonenumber"
          />
        </div>
        <div class="message-content" ref="pwd">
          <input
            type="password"
            class="text2"
            placeholder="请输入密码"
            style="text-align: left"
            v-model="loginPassword"
            @input="checkPassword()"
          />
        </div>
        <div
          class="mybutton"
          @click="phonetrueNext"
         
          :class="{ unable: isUnble }"
        >
          点击进入
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
    md5
  } from "../../static/js/md5";
export default {
  props: {},
  data() {
    return {
      logining: false,
      telPhonenumber: "",
      loginPassword: "",
      newMobile: "",
      PhonePatt: "",
      isUnble:false,
      token:"",
      userName:"",
      ruleForm2: {
        // account: 'admin',
        // checkPass: '123456',
        account: "",
        checkPass: "",
      },
      rules2: {
        // account: [{
        //         required: true,
        //         message: '请输入账号',
        //         trigger: 'blur'
        //     },
        //     //{ validator: validaePass }
        // ],
        // checkPass: [{
        //         required: true,
        //         message: '请输入密码',
        //         trigger: 'blur'
        //     },
        //     //{ validator: validaePass2 }
        // ]
      },
      // checked: true
      userTag:"",//用户标识
    };
  },
  methods: {
    //手机号限制
    checktel: function (e) {
      // this.telPhonenumber = this.ruleNumber(e);
      // this.nextlight();
      // if (this.telPhonenumber.length >= 11) {
      //   this.newMobile = this.telPhonenumber.slice(0, 11);
      //   console.log("yyyyy", this.newMobile);
      //   this.telPhonenumber = this.fomatPhone(this.telPhonenumber.slice(0, 11));
      // } else {
      //   this.newMobile = this.telPhonenumber;
      // }
      // if (this.telPhonenumber.length) {
      //   this.$refs.bm.style.borderBottom = "1px solid #FF9730";
      //   this.mobileIcon = false;
      //   this.showImg = true;
      // } else {
      //   this.$refs.bm.style.borderBottom = "1px solid #e0e0e0";
      //   this.mobileIcon = true;
      //   this.showImg = false;
      // }
    },
    // 正则判断是不是手机号
    phoneNumBlur: function () {
      // var mobile = this.PhonePatt;
      this.telPhonenumber=document.getElementsByClassName("text1")[0].value;
      console.log("aaaa",this.telPhonenumber)
      var mobile=/^(?=.*\d+)(?!.*?([\d])\1{5})[\d]{6}$/
      if (this.newMobile.length > 0) {
        if (mobile.test(this.newMobile)) {
        } else {
          alert("您的手机号码格式有误");
        }
      }
      this.unable();
    },
    checkPassword() { //检测密码，限制密码输入
				this.loginPassword = this.loginPassword.replace(/[^\w]/g, '');
				//  this.nextlight();
				// if (this.loginPassword.length >= 14) {
				// 	this.loginPassword = this.loginPassword.slice(0, 14);
				// }
				// if(this.loginPassword.length){
				// 	this.$refs.pwd.style.borderBottom ='1px solid #FF9730';
				// 	this.showPassWord=true
				// 	this.wordIcon=false
				// }else{
				// 	this.$refs.pwd.style.borderBottom ='1px solid #e0e0e0'
				// 	this.showPassWord=false
				// 	this.wordIcon=true
        // }
        this.unable();

			},
    // keyDown(e){
    //          e.preventDefault()
		// 	},
    //去明细
    phonetrueNext() {
        if (!this.telPhonenumber) {
        alert("账号为空，请确认输入");
        return;
      }
      if (!this.loginPassword) {
        alert("密码为空，请确认输入");
        return;
      }
          let params = {
            account: this.telPhonenumber, //登录手机号
            password: md5(this.loginPassword), //登录密码
          };
          console.log("55555", params);
          let that=this;
          let url = '/ft-oms/backUserAccount/logingInfo.action'
          that.$http.post(url, params).then(res=>{
              if (res.data.code == "200") {
                this.token=res.data.data.token
                this.userName=res.data.data.userName
                this.userTag=res.data.data.limitSign//用户标识
                sessionStorage.setItem("userName",this.userName);
                sessionStorage.setItem("token",this.token);
                sessionStorage.setItem("userTag",this.userTag);
                console.log("token",this.token)
                //接口请求成功，返回链接进行跳转
                  this.$router.push({
                    path: "/",
                    query:{
                      token:this.token,
                      user:this.userName,
                      userTag:this.userTag,
                    }
                  });
              } else {
                alert(res.data.msg)
              }
              //   Indicator.close();
            },
          );
      // console.log("aaa")
      // this.$router.push({
      //   path: "/",
      // });
    },
    phoneNumFocus() {
    },
    unable(){
      if(this.telPhonenumber.length>0&&this.loginPassword.length>0){
        this.isUnble=true
      }else{
        this.isUnble=false
      }
    }
  },
};
</script>

<style scoped>
.login-page-container {
  width: 100%;
  height: 100%;
  background: url("../../static/img/loginBG-1.png") no-repeat;
  background-size: 100% 100%;
  overflow: hidden;
}
.login {
  width: 45.7rem;
  margin: 0 auto;
  display: flex;
  align-items: center;
  margin-top: 10%;
  margin-bottom: 10%;
  /* margin-left: 21.4%;
  margin-right: 21.4%; */
}
.left {
  width: 25.7rem;
  height: 25.7rem;
}
.left img {
  width: 100%;
  height: 100%;
}
.right{
  width: 20rem;
  height: 25.7rem;
  margin: 0 auto;
  background: #fff;
  text-align: center;
}
label.el-checkbox.remember {
  margin: 0px 0px 35px 0px;
}
.title {
  font-weight: 700;
  font-size: 1rem;
  margin-bottom: 1.2rem;
  letter-spacing: 0.05rem;
}
.HZlogo {
  margin-bottom: 0.5rem;
  margin-top: 3rem;
  width: 4rem;
  height: 4rem;
}
.message-content {
  border-bottom: 1px solid #e0e0e0;
  /* padding: 1.3rem 0; */
  padding-top: 1.3rem;
  font-size: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 2.4rem;
  margin-right: 2.4rem;
  
}
.message-content input{
  border: 0;
  outline: none;
}
.message-content .text {
  font-size: 0.5rem;
  color: #333333;
  height: 1.5rem;
  line-height: 1.5rem;
  display: block;
  width: 100%;
  border: 0;
}
.mybutton {
  background-image: linear-gradient(28deg, #ff9730 0%, #ffa75f 0%);
  -webkit-tap-highlight-color: rgba(255, 255, 255, 0);
  -webkit-user-select: none;
  outline: 0;
  opacity: 0.5;
  width: 12rem;
  height: 2.5rem;
  margin: 0 auto;
  border-radius: 1.5rem;
  font-size: 1rem;
  color: #fff;
  line-height: 2.5rem;
  text-align: center;
  margin-top: 2rem;
}
.unable{
  opacity: 1;
}
</style>



// WEBPACK FOOTER //
// login.vue?d2bd5314